/** @jsxImportSource theme-ui */
import React from 'react';
import { ThemeUIStyleObject } from 'theme-ui';

import { sxtheme } from 'utils/cssHelpers';

import { BdIcon } from 'components/_common/BdIcon';
import { IClickable } from 'components/_common/common-props';
import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

const Styles: ThemeUIStyleObject = {
  cursor: 'pointer',
  px: '10px',
  py: '5px',
  bg: '#FFFFFF',
  border: sxtheme(t => `1px solid ${t.colors.sea90}`),
  boxShadow: `0px 4px 4px rgba(17, 17, 17, 0.15);`,
  borderRadius: `20px`,
  '&:hover': { bg: sxtheme(t => t.colors.sea30), transition: '0.5s all' },
  '&:active': { bg: sxtheme(t => t.colors.sea30) },
};

export const ScrollToTopButton: React.FC<IClickable> = ({ onClick }) => (
  <button onClick={onClick} type="button" data-testid="scroll-to-top-button" sx={Styles}>
    <FlexGroup prefix={<BdIcon name="icon-chevron-up" color="sea90" bold />} alignItems="center">
      <Typography variant="subtitle2" color="sea90" inline>
        Back to top
      </Typography>
    </FlexGroup>
  </button>
);
